import '../../constants/const.css';
import React, { useEffect, useRef } from 'react';
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend, ChartOptions, ChartDataset } from 'chart.js';

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend);

interface pitProps {
  dayCount: number;
  planArray: number[];
  rateCapacity: number;
  warningDays?: boolean[];
}

const COLOR_LINE_WIDTH: number = 0;
const GRID_LINE_WIDTH: number = 0;

const BurnGraph2: React.FC<pitProps> = (pitProps) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstanceRef = useRef<Chart | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d');

      if (ctx) {
        // 既存のチャートインスタンスが存在する場合、破棄する
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }

        const labelStr: string[] = [];
        const inLines: number[] = [];
        const overLines: number[] = [];
        const tempDatasets: ChartDataset[] = [];

        if (pitProps.warningDays) {
          for (let i = 0; i < pitProps.warningDays.length; i++) {
            labelStr.push('');
            if (pitProps.warningDays[i]) {
              inLines.push(0);
              overLines.push(pitProps.planArray[i]);
            } else {
              inLines.push(pitProps.planArray[i]);
              overLines.push(0);
            }
          }
          tempDatasets.push({
            data: [...overLines],
            borderColor: 'black',
            backgroundColor: 'blue',
            borderWidth: COLOR_LINE_WIDTH,
            barPercentage: 1,
            categoryPercentage: 1,
          });
        } else {
          for (let i = 0; i < pitProps.planArray.length; i++) {
            labelStr.push('');
            inLines.push(pitProps.planArray[i]);
          }
        }

        tempDatasets.push({
          data: [...inLines],
          borderColor: 'black',
          backgroundColor: 'black',
          borderWidth: COLOR_LINE_WIDTH,
          barPercentage: 1,
          categoryPercentage: 1,
        });

        const tempLines: ChartDataset[] = [];
        tempLines.push({
          type: 'line',
          data: [
            ...Array.from({ length: pitProps.planArray.length }, (_, index) => {
              return pitProps.rateCapacity;
            }),
          ],
          borderColor: 'red',
          borderWidth: 2,
          pointRadius: 0,
        });

        const options: ChartOptions = {
          responsive: true,
          plugins: {
            legend: {
              display: false,
              position: 'top',
            },
            title: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          scales: {
            x: {
              stacked: true,
              beginAtZero: true,
              ticks: {
                display: false,
              },
              grid: {
                color: 'black',
                drawTicks: false,
                lineWidth: GRID_LINE_WIDTH,
              },
            },
            y: {
              stacked: true,
              beginAtZero: true,
              ticks: {
                display: false,
              },
              grid: {
                color: 'black',
                drawTicks: false,
                lineWidth: GRID_LINE_WIDTH,
              },
              max: pitProps.rateCapacity,
            },
          },
        };

        // 新しいチャートを作成して、参照を保持する
        chartInstanceRef.current = new Chart(ctx, {
          type: 'bar',
          data: { labels: labelStr, datasets: [...tempDatasets, ...tempLines] },
          options: options,
        });
      }
    }

    // クリーンアップ時にチャートを破棄する
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [pitProps.dayCount, pitProps.planArray, pitProps.rateCapacity]);

  return <canvas ref={chartRef} style={{ maxHeight: '30px', minWidth: '875px', maxWidth: '875px', marginLeft: '0px' }} />;
};

export default BurnGraph2;
